import { useParams } from 'react-router-dom';
import { useRequest } from 'ahooks';

import { OnboardingLink } from '~services';
import { OnboardingLinkResponse } from '~services/types';

type LinkCompany = OnboardingLinkResponse['data'];

interface UseOnboardingLink {
  cnpj: string;
  companyData?: LinkCompany;
  isLocked: boolean;
  isLoading: boolean;
  error?: Error;
}

function useOnboardingLink(): UseOnboardingLink {
  const { uuid } = useParams();

  const { data, loading, error } = useRequest(
    () => OnboardingLink.getByUuid(uuid),
    {
      ready: !!uuid,
      refreshDeps: [uuid],
    }
  );

  return {
    cnpj: data?.data?.cnpj ?? '',
    companyData: data?.data,
    isLocked: !!uuid && !error,
    isLoading: loading,
    error,
  };
}

export default useOnboardingLink;
